const CLICK = "click";
const HOVER = "hover";
export {
  CLICK,
  HOVER
};
//# sourceMappingURL=constants.js.map
